import IconArrowRight from '@hawkins/icons/lib/iconArrowRight';
import IconArrowLeft from '@hawkins/icons/lib/iconArrowLeft';
import IconChevronRight from '@hawkins/icons/lib/iconChevronRight';
import IconChevronLeft from '@hawkins/icons/lib/iconChevronLeft';

import { useRTL } from './useRTL';

export function useLocaleIcons() {
  const { isRTL } = useRTL();

  return isRTL
    ? {
        IconArrowLeft: IconArrowRight,
        IconArrowRight: IconArrowLeft,
        IconChevronLeft: IconChevronRight,
        IconChevronRight: IconChevronLeft,
      }
    : {
        IconArrowLeft: IconArrowLeft,
        IconArrowRight: IconArrowRight,
        IconChevronLeft: IconChevronLeft,
        IconChevronRight: IconChevronRight,
      };
}
